<template>
	<div class="page">
		<div class="settings">
			<div class="settings-top">
				<div class="settings-head settings-head--exams d-flex align-items-center flex-wrap">
					<router-link to="/settings" class="account-back d-flex align-items-center mr-4">
						<i class="fas fa-chevron-left"></i>
						<div class="account-back-text">Назад</div>
					</router-link>
					<div class="settings-title">Водительские категории</div>
				</div>
			</div>
			<div class="settings-title settings-title--small">Добавить категорию</div>
		</div>
		<div class="school-cabinet">
			<div class="school-cabinet_white-box school-cabinet_white-box--bigger mb-4">
				<div class="school-cabinet_info-form school-cabinet_info-form--full">
					<div class="d-flex justify-content-between flex-wrap">
						<div class="school-cabinet_info-field school-cabinet_info-field--small mb-md-0">
							<input type="text" class="form-control form-control--bordered" placeholder="Категория" v-model="driver_category.category">
						</div>
						<div class="school-cabinet_info-field school-cabinet_info-field--small mb-md-0">
							<input type="text" class="form-control form-control--bordered" placeholder="Название" v-model="driver_category.name">
						</div>
						<div class="school-cabinet_info-field school-cabinet_info-field--small mb-0">
							<button class="btn btn-blue btn-full" @click="save" v-if="!isLoading">Добавить</button>
							<button class="btn btn-blue btn-full" disabled v-else>Добавляем...</button>
						</div>
					</div>
				</div>
			</div>
			<div class="school-cabinet_wrapper">
				<div class="school-cabinet_wrapper-content" data-simplebar data-simplebar-auto-hide="false">
					<div class="school-cabinet_table school-cabinet_table--exam-settings d-none d-md-flex">
						<div class="school-cabinet_table-title mr-1">Категория</div>
						<div class="school-cabinet_table-title mr-1">Название</div>
						<div class="school-cabinet_table-title school-cabinet_table-title--empty"></div>
					</div>
					<div class="school-cabinet_card school-cabinet_card--exam-settings" v-for="category in categories" :key="category.id">
						<div class="school-cabinet_card-info d-flex align-items-center">
							<div class="school-cabinet_card-info-item mr-1">
								<div class="school-cabinet_info-table-title d-md-none">Категория</div>
								<div class="school-cabinet_card-info-text mb-2 mb-md-0">
									<span class="normal">{{ category.category }}</span>
								</div>
							</div>
							<div class="school-cabinet_card-info-item mr-1">
								<div class="school-cabinet_info-table-title d-md-none">Название</div>
								<div class="school-cabinet_card-info-text mb-2 mb-md-0">
									<span class="normal">{{ category.name }}</span>
								</div>
							</div>
							<div class="d-flex align-items-center ml-auto">
								<router-link :to="`/category-edit/${category.driver_category_id}`" class="school-cabinet_card-edit ml-4"></router-link>
								<div class="school-cabinet_card-delete school-cabinet_card-delete--2 ml-4" @click="deleteConfirmation(category.driver_category_id)"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="custom-paginate">
			<pagination v-model="page" v-if="meta.total" :per-page="meta.per_page" :records="meta.total" @paginate="cahngeCategoriesPage" :options="options" />
		</div>
		<v-dialog />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import errorHandlerForResponse from '@/helpers/errorHandlerForResponse.js';

import Pagination from 'vue-pagination-2';

import Vue from 'vue'
import VModal from 'vue-js-modal';
Vue.use(VModal, { dialog: true });

export default {
	name: "Categories",
	data() {
		return {
			page: 1,
			isLoading: false,
			driver_category: {
				category: '',
				name: '',
			},
			options: {
				edgeNavigation: false,
				texts: {
					count: ''
				}
			},
		}
	},
	components: {
		Pagination,
	},
	mounted() {
		this.getCategories(this.page);
	},
	destroyed() {
		this.clearCategories();
	},
	computed: {
		...mapGetters('categories', {
			categories: 'list',
			meta: 'meta',
		}),
	},
	methods: {
		...mapActions('categories', {
			getCategories: 'getList',
			clearCategories: 'clearCategories',
			setCategory: 'save',
			delCategory: 'del',
		}),
		cahngeCategoriesPage() {
			this.getCategories(this.page);
		},
		deleteConfirmation(id) {
		this.$modal.show('dialog', {
			text: 'Вы действительно хотите удалить категорию?',
			buttons: [
			{
				title: 'Да',
				handler: () => {
				this.del(id);
				this.$modal.hide('dialog');
				},
			},
			{
				title: 'Нет',
				handler: () => {
				this.$modal.hide('dialog');
				},
			},
			],
		});
		},
		del(id) {
			let payload = {
				"id": id,
			}
			this.delCategory(payload).then(() => {
				this.clearCategories();
				this.getCategories(this.page);
			})
		},
		save() {
			this.isLoading = true;
			let payload = {
				"driver_category": this.driver_category
			}
			this.setCategory(payload).then(() => {
				this.clearCategories();
				this.isLoading = false;
				this.getCategories(this.page);
				this.driver_category = {
					category: '',
					name: '',
				}
			}).catch((e) => {
				this.isLoading = false;
				this.errorHandlerForResponse(e);
			})
		},
		errorHandlerForResponse,
	}
}
</script>